import { procesarFirmas } from './procesarFirmas';
import { extraerCamposFormulario } from './extraerCamposFormulario';
import { validarDatosFormulario } from './validarDatosFormulario';
import { enviarAlBackendPdf } from './servicioPdfBackend';

export const generarPdfConFirmas = async (opciones) => {
    const {
        flujo = "FICHA",
        data,
        tipoFormulario,
        codigoSecundario,
        tipoFormularioTitulo,
        solicitud,
        firmaRef,
        firmaRefResponsable,
        requiereDobleFirma = false,
        bienestarId = null,
        valora,
        valorb,
        valorc,
        valord,
        fase,
        onExito,
        onError,
        mostrarMensaje,
        /** PDF borrador: sin firmas, marca de agua y nombre _BORRADOR.pdf */
        isDraft = false,
        mensajeExitoBorrador,
    } = opciones;

    try {
        const resultadoFirmas = isDraft
            ? { valido: true, firmas: {} }
            : procesarFirmas(
                firmaRef,
                firmaRefResponsable,
                requiereDobleFirma
            );

        if (!resultadoFirmas.valido) {
            const mensajeError = resultadoFirmas.errores.join(', ');
            if (mostrarMensaje) {
                mostrarMensaje({
                    titulo: 'Firmas incompletas',
                    tipo: 'error',
                    mostrar: true,
                    tiempo: 4000,
                    mensaje: mensajeError,
                });
            }
            if (onError) onError(new Error(mensajeError));
            return false;
        }

        const tipoParaExtraccion = codigoSecundario ? codigoSecundario : tipoFormulario;

        // Combinar campos del formulario
        const datosFormulario = extraerCamposFormulario({
            flujo,
            tipoFormulario: tipoParaExtraccion,
            data,
            solicitud
        });

        // Normalizar versión, mes, TRD y título interno con valores por defecto
        const versionPdf = (valora && String(valora).trim()) || "1";
        const mesPdf = (valorb && String(valorb).trim()) || "SIN MES";
        const trdPdf = (valorc && String(valorc).trim()) || "NO APLICA";

        let tituloBase = (valord && String(valord).trim()) || tipoFormularioTitulo || tipoFormulario || "SIN_TITULO";
        const esTransversal = /^T_\d+$/.test(tipoFormulario);

        let tituloSinCodigo = tituloBase;
        if (esTransversal && fase) {
            const faseNombre = fase.nombre || `Fase ${fase.codigo || fase.id || ''}`;
            tituloSinCodigo = `${tituloBase} ${faseNombre}`;
        }

        let tituloConFase;
        if (esTransversal && fase) {
            const faseNombre = fase.nombre || `Fase ${fase.codigo || fase.id || ''}`;
            tituloConFase = `${tipoFormulario} - ${tituloBase} ${faseNombre}`;
        } else {
            tituloConFase = `${tipoFormulario} - ${tituloBase}`;
        }

        const payloadFinal = {
            ...datosFormulario,
            tipo_formulario: tipoFormulario,
            codigo_secundario: codigoSecundario,
            titulo_formulario: tituloConFase,
            titulo_formulario_sin_codigo: tituloSinCodigo,
            titulo_fase: tituloSinCodigo,
            fecha_generacion: new Date().toISOString(),
            version_pdf: versionPdf,
            mes_pdf: mesPdf,
            trd_pdf: trdPdf,
            titulo_pdf: tituloSinCodigo,
            titulo_pdf_con_codigo: tituloConFase,
            fase_codigo: fase?.codigo || fase?.valorc || fase?.valor || null,
            es_borrador: !!isDraft,
        };

        const validaciones = validarDatosFormulario(tipoFormulario, payloadFinal);

        if (!validaciones.valido) {
            const mensajeError = validaciones.errores.join(', ');
            if (mostrarMensaje) {
                mostrarMensaje({
                    titulo: 'Validación fallida',
                    tipo: 'error',
                    mostrar: true,
                    tiempo: 4000,
                    mensaje: mensajeError,
                });
            }
            if (onError) onError(new Error(mensajeError));
            return false;
        }

        // Enviar al backend
        const response = await enviarAlBackendPdf(
            payloadFinal,
            resultadoFirmas.firmas,
            bienestarId,
            flujo
        );

        if (mostrarMensaje) {
            if (isDraft) {
                mostrarMensaje({
                    titulo: mensajeExitoBorrador || 'Borrador generado',
                    tipo: 'success',
                    mostrar: true,
                    tiempo: 3500,
                    mensaje:
                        'El PDF se guardó como borrador. Completa la ficha y firma para generar el documento final.',
                });
            } else {
                mostrarMensaje({
                    titulo: '¡Documento generado y guardado correctamente!',
                    tipo: 'success',
                    mostrar: true,
                    tiempo: 3000,
                    mensaje: 'Documento generado y guardado correctamente',
                });
            }
        }

        if (onExito) onExito(response);

        return true;

    } catch (error) {
        if (mostrarMensaje) {
            mostrarMensaje({
                titulo: 'Error al generar PDF',
                tipo: 'error',
                mostrar: true,
                tiempo: 4000,
                mensaje: error.message || 'No se pudo generar el documento',
            });
        }
        if (onError) onError(error);
        return false;
    }
};



